<div class="headmod">
  <div class="loader-1" style="height: 45px;">
    <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
  </div>
</div>

<div class="content-modal" style="display: flex;">
  <div class="mod-content active" style="flex-direction: column;width:80%;">
    <div class="loader-2">
      <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
    </div>
    <div class="row-loader">

      <table class="tab-itinerary" style="margin-bottom: 10px;">
        <tbody>
          <tr>
            <td width="30" rowspan="2" class="iti-day">
              <div class="loader-3">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td width="30" class="iti-time">
              <div class="loader-4">
                <div class="text w-100 loading-animate-light" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td>
              <div class="loader-5">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="iti-time">
              <div class="loader-4">
                <div class="text w-100 loading-animate-light" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td>
              <div class="loader-6">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
          </tr>
          <tr>
            <td rowspan="2" class="iti-day">
              <div class="loader-3">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td class="iti-time">
              <div class="loader-4">
                <div class="text w-100 loading-animate-light" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td>
              <div class="loader-5">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="iti-time">
              <div class="loader-4">
                <div class="text w-100 loading-animate-light" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td>
              <div class="loader-6">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
          </tr>
          <tr>
            <td rowspan="2" class="iti-day">
              <div class="loader-3">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td class="iti-time">
              <div class="loader-4">
                <div class="text w-100 loading-animate-light" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td>
              <div class="loader-5">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="iti-time">
              <div class="loader-4">
                <div class="text w-100 loading-animate-light" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td>
              <div class="loader-6">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
          </tr>
          <tr>
            <td rowspan="2" class="iti-day">
              <div class="loader-3">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td class="iti-time">
              <div class="loader-4">
                <div class="text w-100 loading-animate-light" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td>
              <div class="loader-5">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="iti-time">
              <div class="loader-4">
                <div class="text w-100 loading-animate-light" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td>
              <div class="loader-6">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
          </tr>
          <tr>
            <td rowspan="2" class="iti-day">
              <div class="loader-3">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td class="iti-time">
              <div class="loader-4">
                <div class="text w-100 loading-animate-light" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td>
              <div class="loader-5">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="iti-time">
              <div class="loader-4">
                <div class="text w-100 loading-animate-light" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td>
              <div class="loader-6">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
          </tr>
          <tr>
            <td rowspan="2" class="iti-day">
              <div class="loader-3">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td class="iti-time">
              <div class="loader-4">
                <div class="text w-100 loading-animate-light" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td>
              <div class="loader-5">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="iti-time">
              <div class="loader-4">
                <div class="text w-100 loading-animate-light" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td>
              <div class="loader-6">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
          </tr>
          <tr>
            <td rowspan="2" class="iti-day">
              <div class="loader-3">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td class="iti-time">
              <div class="loader-4">
                <div class="text w-100 loading-animate-light" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td>
              <div class="loader-5">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="iti-time">
              <div class="loader-4">
                <div class="text w-100 loading-animate-light" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td>
              <div class="loader-6">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="iti-day">
              <div class="loader-3">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td class="iti-time">
              <div class="loader-4">
                <div class="text w-100 loading-animate-light" style="width:100%; height: 100%;"></div>
              </div>
            </td>
            <td>
              <div class="loader-5">
                <div class="text w-100 loading-animate-dark" style="width:100%; height: 100%;"></div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div id="default" style="margin-left: 20px;">
        <div class="text w-100 loading-animate-light" style="width:100%; height: 85%;"></div>
        </div>
    </div>
  </div>
</div>
